export default function CtaSplit() {
  return (
    <section className="flex flex-col lg:flex-row w-full min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[350px] lg:min-h-[500px]">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20composition%20of%20curated%20lifestyle%20items%20including%20leather%20journal%20notebook%20ceramic%20coffee%20cup%20and%20woven%20textile%20scarf%20arranged%20on%20warm%20sandy%20beige%20textured%20surface%2C%20soft%20directional%20sunlight%20from%20left%20side%20casting%20long%20elegant%20shadows%2C%20rich%20warm%20terracotta%20and%20cream%20color%20palette%2C%20modern%20bohemian%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20organic%20relaxed%20arrangement%2C%20serene%20morning%20atmosphere&width=960&height=1200&seq=superbuy-cta-split-v2&orientation=portrait"
          alt="Organized Product Discovery with SuperBuy Spreadsheet"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
        <div className="absolute top-8 left-8">
          <p className="font-label text-xs text-white/80 tracking-[0.2em] uppercase">Independent Resource</p>
        </div>
        <div className="absolute bottom-10 left-8">
          <p className="font-heading text-white text-4xl md:text-5xl lg:text-6xl font-bold leading-none">
            Organized
          </p>
          <p className="font-heading text-white/90 text-4xl md:text-5xl lg:text-6xl font-bold leading-none mt-1">
            Product
          </p>
          <p className="font-heading text-white/80 text-4xl md:text-5xl lg:text-6xl font-bold leading-none mt-1">
            Discovery
          </p>
        </div>
      </div>

      <div className="lg:w-1/2 bg-white flex items-center justify-center px-8 md:px-16 py-16 lg:py-0">
        <div className="max-w-md text-center lg:text-left">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
            All Roads Lead To
            <br />
            Better Finds
          </h2>
          <p className="font-body text-sm md:text-base text-foreground-500 leading-relaxed mb-8">
            Every SuperBuy Spreadsheet is carefully compiled to connect you with products that match
            your taste and budget. Instead of sifting through endless listings, you get direct access
            to organized collections that save time and eliminate the guesswork from online shopping.
            Discover curated finds across sneakers, streetwear, accessories, and more — all in one
            streamlined resource designed for modern shoppers.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-dark text-center"
            >
              SuperBuy Sheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-outline text-center"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}